import React from 'react'
import PropTypes from 'prop-types'
import {Grid} from '@chakra-ui/react'
import BentoboxCard from './bentobox-card'

const BentoboxGrid = ({
    cards,
    styles,
    inside,
    featured = false,
    flag,
    imageTextPosition,
    localeId,
    categoriesData,
}) => (
    <Grid {...styles?.grid} data-testid="bentobox-grid">
        {cards.map((card, index) => {
            const textPosition = imageTextPosition ?? card.text_position
            const outside =
                card.flag ??
                flag ??
                (textPosition
                    ? textPosition === 'Below image' || textPosition === 'Outside'
                    : !inside)

            return (
                <BentoboxCard
                    key={card._metadata?.uid || index}
                    card={card}
                    styles={styles}
                    inside={!outside}
                    dominant={featured && index === 0}
                    localeId={localeId}
                    categoriesData={categoriesData}
                />
            )
        })}
    </Grid>
)

BentoboxGrid.propTypes = {
    cards: PropTypes.array.isRequired,
    styles: PropTypes.object.isRequired,
    inside: PropTypes.bool.isRequired,
    featured: PropTypes.bool,
    flag: PropTypes.bool,
    imageTextPosition: PropTypes.string,
    localeId: PropTypes.string,
    categoriesData: PropTypes.object,
}

export default BentoboxGrid
